import type { TutorLegalStore } from './interfaces'
import type { DropZoneAcceptedFile } from '@shared/ui/other'
import type { TutorBillingFile, TutorLegalForm } from '../interfaces'

export const getters = {
  getBilling: (state: TutorLegalStore): TutorLegalStore['billing'] => state.billing,
  hasBilling: (state: TutorLegalStore): boolean => !!state.billing,
  isLoading: (state: TutorLegalStore): TutorLegalStore['loading'] => state.loading,
  getForm: (state: TutorLegalStore): TutorLegalStore['form'] => state.form,
  getFieldState: (state: TutorLegalStore) => (key: keyof TutorLegalForm): 'error' | 'static' =>
    state.errors[key] !== undefined ? 'error' : 'static',
  getFieldMessage: (state: TutorLegalStore) => (key: keyof TutorLegalForm): string =>
    state.errors[key] || '',
  getExistingFiles: (state: TutorLegalStore): TutorBillingFile[] => state.existingFiles,
  getPendingFiles: (state: TutorLegalStore): DropZoneAcceptedFile[] => state.pendingFiles,
}
